import React from "react";

import LayerAtom from "../../atoms/Layer";
import StorageGateway from "lib/storage-gateway";
import { toast } from "react-toastify";

/**
 * AdjustmentTypesListPage
 *
 * Layout:
 *    - {@link SSTCFLayout}
 *
 * Sections:
 *    - {@link AdjustmentTypesFilterSection}
        {@link AdjustmentTypesListSection}
 *
 */
class TrainingContentPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isInfoOpen: true,
      editSettings:false,
      createGroupLayer: false,
      authToken: null,
      user_id: null,
      path: "",
      nre_company_id: null,
      company_id: null,
    };

    this.loadData = this.loadData.bind(this);
    this.eventListnerFunction = this.eventListnerFunction.bind(this);
    this.closeLayer = this.closeLayer.bind(this);
    this.postMessageToChild = this.postMessageToChild.bind(this);
  }

  postMessageToChild(messageType) {
    const iFrame = document.getElementById("scheduling");
    iFrame.contentWindow.postMessage(messageType, "*");
  }

  componentWillReceiveProps(props) {
    if (props.refreshFlag) {
      this.postMessageToChild("REFRESH_EDOCS_TAB");
      props.updateState("refrehEDocTabFlag", false);
    }
  }

  loadData() {
    this.postMessageToChild("REFRESH_EDOCS_TAB");
  }

  eventListnerFunction(event) {
    const data =
      event.data && typeof event.data !== "object" && JSON.parse(event.data);
    const message = data?.message;
    if (message === "CLOSE_EDOCS_SLIDER") {
      toast.success(data?.content?.message);
      setTimeout(() => {
        this.setState({ createGroupLayer: false });
      }, 1000);
      this.loadData();
    } else if (message === "OPEN_EDOCS_SLIDER") {
      this.setState({
        createGroupLayer: true,
        path: data?.content?.group_id ?? "create",
        editSettings:data?.content?.editSettings ?? false,
      });
    } else if (message === "FAILED_TOAST") {
      toast.error(data?.content?.toastMessage);
    } else if (message === "SUCCESS_TOAST") {
      toast.success(data?.content?.toastMessage);
    }
  }

  closeLayer(state) {
    if (state === "createGroupLayer") {
      this.setState({ createGroupLayer: false });
    } else {
      this.setState({ editDocumentLayer: false });
    }
  }

  componentDidMount() {
    window.addEventListener("message", this.eventListnerFunction, false);
    const oAuthToken = StorageGateway.get("graniteToken");
    const userID = StorageGateway.get("userId");
    const nre_company_id = StorageGateway.get("nre_company_id");
    const company_id = StorageGateway.get("company_id");
    this.setState({
      authToken: oAuthToken,
      user_id: userID,
      nre_company_id: nre_company_id,
      company_id: company_id,
    });
  }
  componentWillUnmount() {
    window.removeEventListener("message", this.eventListnerFunction);
  }

  render() {
    const {
      createGroupLayer,
      path,
      authToken,
      editSettings,
      user_id,
      nre_company_id,
      company_id,
    } = this.state;

    return (
      <div>
        <div
          style={{
            height: "calc(100vh - 102px - 100px)",
            marginRight: "-15px",
          }}
        >
          <iframe
            id="scheduling"
            title="worksana-nre"
            width="100%"
            height="100%"
            frameBorder="0"
            style={{ width: "100%", height: "100%" }}
            src={`${
              process.env.REACT_APP_WMAPPER_BASE_URL
            }/e-docs/?access_token=${authToken}&user_id=${user_id}&companyId=${company_id ||
              nre_company_id}&content_type=LEARNING_CENTER`}
          />
        </div>

        {createGroupLayer && (
          <LayerAtom
            active={true}
            path={`/e-docs/${path}/?access_token=${authToken}&user_id=${user_id}&companyId=${company_id ||
              nre_company_id}&editSettings=${editSettings}&content_type=LEARNING_CENTER`}
            setToggle={() => this.closeLayer("createGroupLayer")}
          />
        )}
      </div>
    );
  }
}

export default TrainingContentPage;
